import React from 'react';
import { Wrapper, Option, Shimmer, Title, Subtitle } from './styled';

export const PlaceholderShimmer: React.FC = () => (
  <Wrapper>
    <Option>
      <Title>
        <Shimmer />
      </Title>
      <Subtitle>
        <Shimmer />
      </Subtitle>
    </Option>
    <Option>
      <Title>
        <Shimmer />
      </Title>
      <Subtitle>
        <Shimmer />
      </Subtitle>
    </Option>
    <Option>
      <Title>
        <Shimmer />
      </Title>
      <Subtitle>
        <Shimmer />
      </Subtitle>
    </Option>
  </Wrapper>
);
